import { replaceDcDbmToken } from 'common/js/dsp-token';
import { getParentWindow } from 'common/js/window-ancestors';
import { ImageExperienceParser } from '../experience-parser/image-experience-parser';
import { buildChainedClickUrl } from '../helpers/build-click-url';
import {
  ContextAugmentedWindow,
  ParametersExtractor,
  Context
} from '../parameters-extractor/parameters-extractor';

export type ClickUrls = {
  urlToOpen: string | undefined;
  pixelUrl: string | undefined;
};

export class ClickUrlsRetriever {
  public static readonly DSP_TOKEN = 'DSP_token';
  public static readonly CLICK_URL = 'click_url';

  constructor(
    private experienceParser: ImageExperienceParser,
    private parametersExtractor: ParametersExtractor
  ) {}

  getClickUrls(aWindow: ContextAugmentedWindow): ClickUrls {
    const clickStrategy = this.parametersExtractor.getContextParameters<string>(
      'click_strategy',
      aWindow,
      'parameters'
    );
    const result: ClickUrls = {
      urlToOpen: undefined,
      pixelUrl: undefined
    };

    const tagContext:
      | Context
      | undefined = this.parametersExtractor.getAdContext(aWindow);
    const parentWindow: Window | undefined = getParentWindow(aWindow);
    const dspToken: string = this.parametersExtractor.getContextParameters<
      string
    >(ClickUrlsRetriever.DSP_TOKEN, aWindow);

    const experienceClickUrl = this.experienceParser.getClickUrl();
    const tagClickUrl: string | undefined = tagContext?.clickUrl as
      | string
      | undefined;
    const campaignClickUrl = parentWindow
      ? this.parametersExtractor.getContextParameters<string>(
          ClickUrlsRetriever.CLICK_URL,
          parentWindow,
          'parameters'
        )
      : undefined;

    if (clickStrategy === 'chained') {
      result.urlToOpen = ClickUrlsRetriever.buildChainedUrl(
        experienceClickUrl || campaignClickUrl || '',
        tagClickUrl
      );
      return {
        urlToOpen: ClickUrlsRetriever.replaceDspToken(
          result.urlToOpen ?? '',
          dspToken
        ),
        pixelUrl: ClickUrlsRetriever.replaceDspToken(
          result.pixelUrl ?? '',
          dspToken
        )
      };
    }

    if (experienceClickUrl) {
      result.urlToOpen = experienceClickUrl;
      this.pushDspTracking(tagClickUrl, result);
    } else if (campaignClickUrl) {
      result.urlToOpen = campaignClickUrl;
      this.pushDspTracking(tagClickUrl, result);
    } else if (tagClickUrl) {
      result.urlToOpen = tagClickUrl;
    }

    return {
      urlToOpen: ClickUrlsRetriever.replaceDspToken(
        result.urlToOpen ?? '',
        dspToken
      ),
      pixelUrl: ClickUrlsRetriever.replaceDspToken(
        result.pixelUrl ?? '',
        dspToken
      )
    };
  }

  protected pushDspTracking(
    tagClickUrl: string | undefined,
    result: ClickUrls
  ): void {
    tagClickUrl &&
      tagClickUrl !== this.experienceParser.getClickUrl() &&
      (result.pixelUrl = tagClickUrl);
  }

  public static buildChainedUrl(
    campaignClickUrl: string,
    tagClickUrl: string | undefined
  ): string {
    if (!tagClickUrl) {
      return campaignClickUrl;
    }
    return buildChainedClickUrl(campaignClickUrl, tagClickUrl);
  }

  public static replaceDspToken(url: string, dspToken: string): string {
    if (!url) {
      return url;
    }
    return replaceDcDbmToken(url, dspToken);
  }
}
